import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "inner-modal inner-modal--acc" }
const _hoisted_2 = { class: "acc" }
const _hoisted_3 = { class: "acc__inner" }
const _hoisted_4 = { class: "acc__form" }
const _hoisted_5 = { class: "acc__head" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "acc__heading" }, "Create a New Account", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Creating an account lets you save your wishlist and open them on other devices such as your phone.", -1 /* HOISTED */)
const _hoisted_8 = { class: "text-danger" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "emailAddress" }, [
  /*#__PURE__*/_createTextVNode("Email address"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, [
  /*#__PURE__*/_createTextVNode("Password"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_14 = { class: "invalid-feedback" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "confirmPassword" }, [
  /*#__PURE__*/_createTextVNode("Confirm Password"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_17 = { class: "invalid-feedback" }
const _hoisted_18 = { class: "text-center mt-3" }
const _hoisted_19 = { class: "acc__more" }

import {computed, ref} from 'vue';
import { useStore } from 'vuex';
import Cta from "Vue/components/lockDesigner/components/shared/Cta.vue";
import {UserRegister} from "Api/apis";
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  props: {
	forwardingRoute: String,
	closeModal: Boolean,
	pathPrefix: String
},
  setup(__props) {

const props = __props

const componentName = 'AccountRegistrationModal';
const store = useStore();
const router = useRouter();
const validationErrors = ref<string[]>([]);
const formValidationErrors = ref<any>({});



const registrationInfo = ref<{ emailAddress: string, password: string, confirmPassword: string }>({
	emailAddress: "",
	password: "",
	confirmPassword: "",
});

const create = async () => {
	await UserRegister(registrationInfo.value).then(async(response) => {
		if(response.data) {
			await store.commit('updateAuthToken', response.data.authToken);
			await router.push(props.forwardingRoute);
			if(props.closeModal) {
				await store.dispatch('closeModal');
			}
		} else {
			if(response.isErrors) {
				if(response.errorDetail.isError) {
					validationErrors.value = response.userFriendlyMessages;
				}
				if(response.formValidationMessages) {
					formValidationErrors.value = response.formValidationMessages;
				}
			}
		}
	});
};

const login = async() => {
	await router.push(`${props.pathPrefix}/login`);
};

const forgotPassword = async() => {
	await router.push(`${props.pathPrefix}/forgot-password`);
};


const closeModal = async() => {
	await store.dispatch('closeModal');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            (validationErrors.value.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(validationErrors.value, (error) => {
                  return (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(error), 1 /* TEXT */))
                }), 256 /* UNKEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((registrationInfo.value.emailAddress) = $event)),
              id: "emailAddress",
              class: _normalizeClass([`form-control`, formValidationErrors.value?.emailAddress?.length ? 'is-invalid' : ''])
            }, null, 2 /* CLASS */), [
              [_vModelText, registrationInfo.value.emailAddress]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formValidationErrors.value?.emailAddress, (error) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_11, " • " + _toDisplayString(error), 1 /* TEXT */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((registrationInfo.value.password) = $event)),
              id: "password",
              class: _normalizeClass([`form-control`, formValidationErrors.value?.password?.length ? 'is-invalid' : ''])
            }, null, 2 /* CLASS */), [
              [_vModelText, registrationInfo.value.password]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formValidationErrors.value?.password, (error) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_14, " • " + _toDisplayString(error), 1 /* TEXT */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((registrationInfo.value.confirmPassword) = $event)),
              class: _normalizeClass(["form-control", [`form-control`, formValidationErrors.value?.confirmPassword?.length ? 'is-invalid' : '']]),
              id: "confirmPassword"
            }, null, 2 /* CLASS */), [
              [_vModelText, registrationInfo.value.confirmPassword]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formValidationErrors.value?.confirmPassword, (error) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_17, " • " + _toDisplayString(error), 1 /* TEXT */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(Cta, {
              type: "primary",
              size: "lg",
              label: "Create",
              onOnClick: create,
              icon: [],
              iconAlignment: "left"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(Cta, {
            type: "outline",
            size: "lg",
            label: "Login",
            onOnClick: login,
            icon: [],
            iconAlignment: "left"
          }),
          _createVNode(Cta, {
            type: "outline",
            size: "lg",
            label: "Forgot Password",
            onOnClick: forgotPassword,
            icon: [],
            iconAlignment: "left"
          })
        ])
      ])
    ]),
    _createElementVNode("button", {
      onClick: closeModal,
      class: "inner-modal__close"
    }, "×")
  ]))
}
}

})